export default __webpack_public_path__ + "static/media/weather.befab165.PNG";